// Alguns endpoints devolvem texto UTF-8 lido como Latin-1 ("CambÃ©" em vez de "Cambé"). Desfaz essa
// conversão dupla; se o texto já estiver correto, o decode falha e o texto volta como veio.
export default function corrigirAcentos(texto) {
    if (!texto || !/[ÃÂ]/.test(texto)) return texto;
    try {
        return decodeURIComponent(escape(texto));
    } catch (e) {
        return texto;
    }
}
